import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import {
  BRAND_PURPLE,
  NAV_Z_INDEX,
  STANDARD_NAV_HEIGHT,
} from "@/css/constants";

interface ProgressBarProps {
  width: number;
  top?: number;
  animating?: boolean;
}

export function ProgressBar({
  width,
  top,
  animating = false,
}: ProgressBarProps) {
  return (
    <Flex
      style={{
        position: "fixed",
        top: top || STANDARD_NAV_HEIGHT,
        left: 0,
        right: 0,
        zIndex: NAV_Z_INDEX,
      }}
      justifyContent="center"
    >
      <Flex width={1}>
        {animating ? (
          <AnimatingBar />
        ) : (
          <Box
            width={width}
            style={{
              borderTop: `4px solid ${BRAND_PURPLE}`,
              transition: "width 300ms ease",
            }}
          />
        )}
      </Flex>
    </Flex>
  );
}

const gradient = keyframes`
  0%   { background-position: 0 0; }
  100% { background-position: -200% 0; }
`;

const AnimatingBar = styled(Box)`
  background: repeating-linear-gradient(
    to right,
    rgba(100, 102, 235, 0.8) 0%,
    rgba(100, 102, 235, 0.05) 25%,
    rgba(100, 102, 235, 0.8) 50%,
    rgba(100, 102, 235, 0.05) 75%,
    rgba(100, 102, 235, 0.8) 100%
  );
  width: 100%;
  background-size: 200% auto;
  background-position: 0 100%;
  animation: ${gradient} 4s infinite;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  height: 4px;
`;
